import { catchError, finalize, tap } from 'rxjs/operators';
import { ToastService } from './../services/toast.service';
import { SpinnerService } from './../spinner/spinner.service';
import { UserAccountClient } from './../models/models.swagger.generated';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { of } from 'rxjs';
import { AppErrorMessagesService } from '../services/app-error-messages.service';
import { ErrorType } from 'src/app/core/routing/error-types';
import { loginRoute } from 'src/app/core/routing/route-names';
import { TitleBarComponent } from '../shared/title-bar/title-bar.component';
import { TranslateModule } from '@ngx-translate/core';

import { RouterLink } from '@angular/router';
import { AppErrorMessagesComponent } from '../error-messages/app-error-messages.component';
import { MarkAsteriskDirective } from 'src/app/directives/mark-asterisk.directive';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    imports: [RouterLink, AppErrorMessagesComponent, TitleBarComponent, TranslateModule, ReactiveFormsModule, MarkAsteriskDirective]
})
export class ForgotPasswordComponent implements OnInit {

  constructor(
    private formBuilder: UntypedFormBuilder,
    private userAccountClient: UserAccountClient,
    private spinnerService: SpinnerService,
    private toastService: ToastService,
    private errorMessageService: AppErrorMessagesService,
  ) {
  }

  public forgotPasswordForm: UntypedFormGroup;
  public forgotPasswordSuccess = false;
  public loginRoute = loginRoute;

  public get formFields() {
    return this.forgotPasswordForm.controls;
  }

  public formSubmit() {
    if (this.forgotPasswordForm.valid) {
      const userName = this.forgotPasswordForm.get('userName').value;
      if (userName.includes('\\')) {
        this.toastService.showError(
          'i18n.base.forgot-password.errors.domain-user.title',
          'i18n.base.forgot-password.errors.domain-user.message');
      } else {
        this.spinnerService.show();
        this.userAccountClient.forgotPassword(
          {
            username: userName,
          } as any).pipe(
          tap(() => {
            this.forgotPasswordSuccess = true;
          }),
          finalize(() => this.spinnerService.hide()),
          catchError((error: any) => {
            this.handleError(error);
            return of(error);
          }),
        ).subscribe();
      }
    }
  }

  private handleError(error: any) {
    const apiErrorCode = this.errorMessageService.getApiErrorCode(error);
    let i18nErrorMessage = 'i18n.errors.server-error.message';
    const i18nErrorTitle = 'i18n.errors.server-error.title';
    if (apiErrorCode) {
      i18nErrorMessage = 'i18n.base.forgot-password.errors.' + apiErrorCode;
    }
    this.toastService.showError(i18nErrorTitle, i18nErrorMessage,
      null, ErrorType.serverError);
  }

  ngOnInit() {
    this.forgotPasswordForm = this.formBuilder.group({
      userName: [null, Validators.required],
    });
  }
}
